import Vue from 'vue';

function dateFormat(date: Date | number | string | null | undefined, withTime: boolean = true, asText: boolean = false) {
    if (!date) return '';

    const dt = new Date(date);

    if (asText) {
        return dt.toLocaleDateString('default', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    const fullYear = `${dt
        .getDate()
        .toString()
        .padStart(2, '0')}/${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt
        .getFullYear()
        .toString()
        .padStart(4, '0')}`;

    const time = ` ${dt
        .getHours()
        .toString()
        .padStart(2, '0')}:${dt
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${dt
        .getSeconds()
        .toString()
        .padStart(2, '0')}`;

    return withTime ? fullYear + time : fullYear;
}

Vue.filter('dateFormat', dateFormat);

export default dateFormat;
